import { CheckCircle } from "@phosphor-icons/react";
import { useT, PublicLangToggle } from "@/i18n";

export default function TradesmanSignedOut() {
  const { t } = useT();
  return (
    <div className="min-h-screen bg-[#f4f4f5] flex items-center justify-center p-6" data-testid="tradesman-signed-out">
      <div className="bg-white border-4 border-[#0f172a] shadow-[8px_8px_0px_#00C4CC] p-8 max-w-sm w-full text-center">
        <div className="flex justify-end mb-2"><PublicLangToggle dark={false}/></div>
        <CheckCircle weight="fill" size={44} className="mx-auto text-emerald-600 mb-2"/>
        <div className="font-display font-black text-2xl uppercase">{t("tp.signed_out_title")}</div>
        <div className="text-sm text-slate-600 mt-3">{t("tp.signed_out_body")}</div>
        <div className="mt-6 text-[10px] font-black uppercase tracking-widest text-slate-400">{t("tp.footer")}</div>
      </div>
    </div>
  );
}
